// ************** fronto.space.js **************
// finiding empty area
import * as d3 from 'd3';
import './default.js';

class FrontoSpace {
  constructor(sel, gsize) {
    this.placeSelector = sel;
    this.occupied = [];
    this.emptySpaceGrid = [];
    this.cellSize = gsize || 10;
    this.threshold = { area: 20, width: 1, height: 1 };
    this.originPlace = document.querySelector(sel)
    let placeBBox = document.querySelector(sel).getBoundingClientRect();
    this.originSpace = {
      width: placeBBox.width,
      height: placeBBox.height
    }
    this.n_rows = Math.ceil(this.originSpace.height / this.cellSize);
    this.n_cols = Math.ceil(this.originSpace.width / this.cellSize);
    this.makeGrid();
  }
  register(a1, a2, a3, a4) {
    let args = Array.from(arguments), bboxObj = {};
    if (args.length == 1 && args[0].constructor.name === "Object") {
      // if a1 = {x1: , y1: , x2: , y2: }, a1 = {x: , y: , width: , height: }
      bboxObj = JSON.parse(JSON.stringify(a1))
      if (a1.x !== undefined) {
        bboxObj.x1 = a1.x;
        delete bboxObj.x;
      }
      if (a1.y !== undefined) {
        bboxObj.y1 = a1.y;
        delete bboxObj.y;
      }
      if (a1.width !== undefined) {
        bboxObj.x2 = a1.width + bboxObj.x1;
        delete bboxObj.width;
      }
      if (a1.height !== undefined) {
        bboxObj.y2 = a1.height + bboxObj.y1;
        delete bboxObj.height;
      }

    } else if (args.length == 4 && args.every(d => (typeof d == 'number'))) {
      // if a1, a2, a3, a4 == x1, y1, x2, y2
      bboxObj = { x1: a1, y1: a2, x2: a3, y2: a4 };
    } else if (args.length == 2 && args.every(d => (typeof d == 'number' && d.length == 2))) {
      // if a1 = [x1, y1], a2 = [x2, y2]
      bboxObj = { x1: a1[0], y1: a1[1], x2: a2[0], y2: a2[1] };
    }
    this.occupied.push(bboxObj);
    let occ = {
      x1: Math.floor(bboxObj.x1 / this.cellSize), x2: Math.ceil(bboxObj.x2 / this.cellSize),
      y1: Math.floor(bboxObj.y1 / this.cellSize), y2: Math.ceil(bboxObj.y2 / this.cellSize)
    };
    for (let i = occ.x1; i < occ.x2; i++) {
      for (let j = occ.y1; j < occ.y2; j++) {
        if (this.spaceGrid[i + "_" + j])
          this.spaceGrid[i + "_" + j].empty = false;
      }
    }
  }
  makeGrid() {
    let cellSize = this.cellSize;
    let grid = {};
    for (let i = 0; i < this.n_cols; i++) {
      for (let j = 0; j < this.n_rows; j++) {
        grid[i + "_" + j] = { pos: [i * cellSize, j * cellSize], empty: true };
      }
    }
    this.spaceGrid = grid;
  }
  getEmptySpace() {
    this.spaceGrid;
  }
  visualizeEmptySpace() {
    let style = `.fr-cell {
      border: 1px solid rgba(0, 184, 64, 0.75);
      background-color: rgba(0, 255, 89, 0.25);
      box-sizing: border-box;
    }
    `;
    let styleDef = document.createElement("style")
    styleDef.setAttribute("id", "fronto-emptySpaceVis-style")
    styleDef.innerHTML = style;
    document.getElementsByTagName("head")[0].append(styleDef);
    let vis = document.createElement("div");
    vis.setAttribute("id", "fronto-emptySpaceVis");
    vis.style.position = "absolute";
    vis.style.left = 0;
    vis.style.top = 0;
    let emptySpace = this.spaceGrid;
    Object.keys(emptySpace).forEach(cell_id => {
      if (emptySpace[cell_id].empty) {
        let cell = document.createElement("div");
        cell.setAttribute("id", "fronto-emptySpaceVis-" + cell_id);
        cell.style.position = "absolute";
        cell.style.left = emptySpace[cell_id].pos[0] + "px";
        cell.style.top = emptySpace[cell_id].pos[1] + "px";
        cell.style.width = "10px";
        cell.style.height = "10px";
        cell.className = 'fr-cell';
        vis.appendChild(cell);
      }
    });
    this.originPlace.appendChild(vis);
  }
  visualizeContiguousEmptySpace(topN) {
    let colors = [
      ['rgba(77, 0, 148, 0.75)', 'rgba(129, 0, 247, 0.25)'],
      ['rgba(163, 0, 82, 0.75)', 'rgba(255, 0, 128, 0.25)'],
      ['rgba(0, 87, 163, 0.75)', 'rgba(0, 145, 255, 0.25)'],
      ['rgba(179, 128, 0, 0.75)', 'rgba(255, 183, 0, 0.25)'],
      ['rgba(0, 159, 173, 0.75)', 'rgba(0, 234, 255, 0.25)'],
      ['rgba(168, 45, 0, 0.75)', 'rgba(252, 101, 0, 0.25)']
    ]
    let styleDef = document.createElement("style")
    styleDef.setAttribute("id", "fronto-emptySpaceVis-style-contiguous")
    document.getElementsByTagName("head")[0].append(styleDef);
    if (topN) {
      let contig = this.contiguousEmptySpace
      let sorted = Object.keys(contig).sort((a, b) => {
        return (contig[b].cellX2 - contig[b].cellX1 + 1) * (contig[b].cellY2 - contig[b].cellY1 + 1) - (contig[a].cellX2 - contig[a].cellX1 + 1) * (contig[a].cellY2 - contig[a].cellY1 + 1);
      });
      for (let index = 0; index < topN; index++) {
        let areaId = sorted[index];
        let emptySpace = this.contiguousEmptySpace[areaId];
        if (index < 6) {
          let style = `
      
          .fr-cell-$index$ {
            border: 1px solid $color1$;
            background-color: $color2$;
            box-sizing: border-box;
          }`;
          style = style.replace('$index$', (index % 6).toString());
          style = style.replace('$color1$', colors[index % 6][0]);
          style = style.replace('$color2$', colors[index % 6][1]);
          styleDef.innerHTML = styleDef.innerHTML + style;
        }

        let vis = document.createElement("div");
        vis.setAttribute("id", "fronto-emptySpaceVis-contiguous-" + index);
        vis.className = 'fr-cell-' + (index % 6) + " fr-cell-contig";
        vis.style.position = "absolute";
        vis.style.left = emptySpace.cellX1 * 10 + "px";
        vis.style.top = emptySpace.cellY1 * 10 + "px";
        vis.style.width = (emptySpace.cellX2 - emptySpace.cellX1 + 1) * 10 + "px";
        vis.style.height = (emptySpace.cellY2 - emptySpace.cellY1 + 1) * 10 + "px";

        this.originPlace.appendChild(vis);
      }
    } else {
      Object.keys(this.contiguousEmptySpace).forEach((areaId, index) => {
        let emptySpace = this.contiguousEmptySpace[areaId];
        if (index < 6) {
          let style = `
      
          .fr-cell-$index$ {
            border: 1px solid $color1$;
            background-color: $color2$;
            box-sizing: border-box;
          }`;
          style = style.replace('$index$', (index % 6).toString());
          style = style.replace('$color1$', colors[index % 6][0]);
          style = style.replace('$color2$', colors[index % 6][1]);
          styleDef.innerHTML = styleDef.innerHTML + style;
        }

        let vis = document.createElement("div");
        vis.setAttribute("id", "fronto-emptySpaceVis-contiguous-" + index);
        vis.className = 'fr-cell-' + (index % 6) + " fr-cell-contig";
        vis.style.position = "absolute";
        vis.style.left = emptySpace.cellX1 * 10 + "px";
        vis.style.top = emptySpace.cellY1 * 10 + "px";
        vis.style.width = (emptySpace.cellX2 - emptySpace.cellX1 + 1) * 10 + "px";
        vis.style.height = (emptySpace.cellY2 - emptySpace.cellY1 + 1) * 10 + "px";

        this.originPlace.appendChild(vis);
      })
    }
  }
  hideEmptySpace() {
    document.querySelector("#fronto-emptySpaceVis").remove();
    document.querySelectorAll(".fr-cell-contig").forEach(d => d.remove());
    document.querySelector("#fronto-emptySpaceVis-style").remove();
    document.querySelector("#fronto-emptySpaceVis-style-contiguous").remove();
  }
  log() {
    this.occupied.forEach(occ => console.log("Space Occupation" + JSON.stringify(occ)))
  }
  getContiguousEmptySpace() {
    let areas = {}
    for (let i = 0; i < this.n_cols; i++) {
      for (let j = 0; j < this.n_rows; j++) {
        if (this.spaceGrid[i + "_" + j].empty) {
          let tempAreas = this.findLargestContiguousEmptySpace(i, j);
          tempAreas.forEach(tempArea => {
            let flag = true;
            Object.keys(this.spaceGrid).forEach(areaId => {
              if (areas[areaId]) {
                if (tempArea.cellX1 <= areas[areaId].cellX1 && areas[areaId].cellX2 <= tempArea.cellX2 &&
                  tempArea.cellY1 <= areas[areaId].cellY1 && areas[areaId].cellY2 <= tempArea.cellY2) {
                  flag = true;
                  delete areas[areaId];
                } else if (areas[areaId].cellX1 <= tempArea.cellX1 && tempArea.cellX2 <= areas[areaId].cellX2 &&
                  areas[areaId].cellY1 <= tempArea.cellY1 && tempArea.cellY2 <= areas[areaId].cellY2) {
                  flag = false;
                }
                if ((tempArea.cellX2 - tempArea.cellX1) <= this.threshold.width
                  || (tempArea.cellY2 - tempArea.cellY1) <= this.threshold.height
                  || (tempArea.cellX2 - tempArea.cellX1) * (tempArea.cellY2 - tempArea.cellY1) <= this.threshold.area) {
                  flag = false;
                }
              }
            })
            if (flag) areas[i + "_" + j] = tempArea;
          });
        }
      }
    }
    this.contiguousEmptySpace = areas;
    return Promise.resolve(this);
  }
  findLargestContiguousEmptySpace($i, $j) {
    let dynamic = {}, xFar, yFar;
    for (let i = $i; i < this.n_cols; i++) {
      if (this.spaceGrid[i + "_" + $j].empty) {
        xFar = i;
      } else {
        break;
      }
    }
    for (let j = $j; j < this.n_rows; j++) {
      if (this.spaceGrid[$i + "_" + j].empty) {
        yFar = j;
      } else {
        break;
      }
    }
    for (let i = $i; i < xFar + 1; i++) {
      for (let j = $j; j < yFar + 1; j++) {
        if (this.spaceGrid[i + "_" + j].empty) {
          if (i == $i || j == $j) dynamic[i + "_" + j] = (i - $i + 1) * (j - $j + 1)
          else if (dynamic[(i - 1) + "_" + j] > 0 && dynamic[i + "_" + (j - 1)] > 0 && dynamic[(i - 1) + "_" + (j - 1)] > 0) {
            dynamic[i + "_" + j] = (i - $i + 1) * (j - $j + 1);
          } else {
            dynamic[i + "_" + j] = -1;
          }
        } else {
          dynamic[i + "_" + j] = -1;
        }
      }
    }
    let maxArea = d3.max(Object.values(dynamic));
    return Object.keys(dynamic).filter(di => dynamic[di] == maxArea).map(di => {
      return { cellX1: $i, cellY1: $j, cellX2: parseInt(di.split("_")[0]), cellY2: parseInt(di.split("_")[1]) };
    });
  }
  getLargestContiguousEmptySpace(conversion) {
    let contig = this.contiguousEmptySpace
    let sorted = Object.keys(contig).sort((a, b) => {
      return (contig[b].cellX2 - contig[b].cellX1 + 1) * (contig[b].cellY2 - contig[b].cellY1 + 1) - (contig[a].cellX2 - contig[a].cellX1 + 1) * (contig[a].cellY2 - contig[a].cellY1 + 1);
    });
    if (!conversion) return contig[sorted[0]];
    else {
      let res = contig[sorted[0]], cellSize = this.cellSize;
      return {
        cellX1: res.cellX1 * cellSize,
        cellX2: res.cellX2 * cellSize,
        cellY1: res.cellY1 * cellSize,
        cellY2: res.cellY2 * cellSize
      }
    }
  }
}

function frontoCompileSpace(placeSelector) {
  let place = document.querySelector(placeSelector);
  let placeBBox = place.getBoundingClientRect();
  let markPlaceTranslate = document.querySelector(placeSelector + " svg>g").getAttribute("transform").split(/[\(,\)]/g).slice(1, 3).map(d => +d);
  let marks = document.querySelectorAll(placeSelector + " path[role=graphics-symbol");
  let annos = document.querySelectorAll(placeSelector + " annotation[data-role=internalAnnotation]");
  let emphs = document.querySelectorAll(placeSelector + " emphasis[data-role=informaltionalMarks]");
  let texts = document.querySelectorAll(placeSelector + " replacement[data-role=text-replacement]");
  let legends = document.querySelectorAll(placeSelector + " div[data-role=legend-replacement]");
  let compiled = new FrontoSpace(placeSelector)
  marks.forEach(markItem => {
    let bbox = markItem.getBoundingClientRect();
    compiled.register(bbox.x - placeBBox.x, bbox.y - placeBBox.y, bbox.width + bbox.x - placeBBox.x, bbox.height + bbox.y - placeBBox.y)
  });
  annos.forEach(annoItem => {
    let bbox = annoItem.getBoundingClientRect();
    compiled.register(bbox.x - placeBBox.x, bbox.y - placeBBox.y, bbox.width + bbox.x - placeBBox.x, bbox.height + bbox.y - placeBBox.y)
  });
  emphs.forEach(emphItem => {
    let bbox = emphItem.getBoundingClientRect();
    compiled.register(bbox.x - placeBBox.x, bbox.y - placeBBox.y, bbox.width + bbox.x - placeBBox.x, bbox.height + bbox.y - placeBBox.y)
  });
  texts.forEach(textItem => {
    let bbox = textItem.getBoundingClientRect();
    compiled.register(bbox.x - placeBBox.x, bbox.y - placeBBox.y, bbox.width + bbox.x - placeBBox.x, bbox.height + bbox.y - placeBBox.y)
  });
  legends.forEach(legendItem => {
    let bbox = legendItem.getBoundingClientRect();
    compiled.register(bbox.x - placeBBox.x, bbox.y - placeBBox.y, bbox.width + bbox.x - placeBBox.x, bbox.height + bbox.y - placeBBox.y)
  });
  return compiled;
}

export { frontoCompileSpace };